import { BaseError } from '@webapp/core/utils/errors/BaseError'

type ERRORS =
  | 'SPENDING_CARD_DOES_NOT_EXIST'
  | 'ERROR_GETTING_SPENDING_CARD_DETAILS'
  | 'ERROR_GETTING_VIRTUAL_CARD_PAYMENT_DETAILS'
  | 'ERROR_GETTING_CARD_PIN'
  | 'ERROR_GETTING_MONTHLY_STATEMENT'
  | 'ERROR_ACTIVATING_PHYSICAL_CARD'
  | 'ERROR_ACTIVATING_STRIPE_PHYSICAL_CARD'
  | 'GENERAL_ERROR_ACTIVATING_PHYSICAL_CARD'

export class SpendingCardUseCaseErrors extends BaseError<ERRORS> {}
